module.exports = __webpack_public_path__ + "img/news-icon.a741982d.svg";